// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Settings',
  subtitle: 'Manage system settings',
  telegram: {
    title: 'Telegram Notifications',
    enable: 'Enable Telegram notifications',
    botToken: 'Telegram Bot Token *',
    botTokenPlaceholder: '123456789:ABCdefGHIjklMNOpqrsTUVwxyz',
    botTokenHint: 'Enter the bot token you received from BotFather',
    chatId: 'Telegram Chat ID *',
    chatIdPlaceholder: '123456789',
    chatIdHint: 'Enter the chat ID where you want to receive notifications (you can learn it with @userinfobot)',
    sendTest: 'Send Test Notification',
    save: 'Save Settings',
    sending: 'Sending...',
    saving: 'Saving...',
    testNotification: 'Test Notification',
    testMessage: 'Test Notification - Telegram notifications are working!',
    sendingTest: 'Sending Telegram test message...',
    testSent: 'Test notification sent successfully!',
    botTokenRequired: 'Please enter bot token and chat ID first',
    botTokenInvalid: 'Bot token is invalid.',
    chatIdNotFound: 'Chat ID not found.',
    backendNotFound: 'Backend endpoint not found.',
    apiError: 'API response error',
    corsError: 'Backend is not running.',
    instructions: 'Creating Telegram Bot:',
    step1: 'Chat with @BotFather on Telegram',
    step2: 'Send /newbot command',
    step3: 'Choose bot name and username',
    step4: 'BotFather will give you a token',
    step5: 'Chat with @userinfobot to get Chat ID',
    notificationInfo: 'Notification Sending:',
    notificationInfo1: 'Automatic notification is sent when server goes offline',
    notificationInfo2: 'Notifications are only sent when transitioning from online to offline',
    notificationInfo3: 'Server status is checked every 5 minutes'
  },
  exchangeRates: {
    title: 'Exchange Rates',
    autoFetch: 'Auto Fetch Rates',
    fetching: 'Fetching...',
    info: 'Rate Info:',
    infoText: 'Rates are calculated based on TL.',
    usd: 'USD/TL Rate *',
    eur: 'EUR/TL Rate *',
    gbp: 'GBP/TL Rate *',
    gold: 'Gram Gold/TL Rate *',
    placeholder: 'Ex: 34.50',
    goldHint: 'Gram gold price must be updated manually',
    save: 'Save Rates',
    saveRates: 'Save Rates',
    fetchingRates: 'Fetching rates...',
    ratesUpdated: 'Rates updated',
    ratesFetchError: 'Rates could not be fetched.',
    goldFetchError: 'Gold price could not be fetched automatically.',
    tcmbError: 'Rates could not be fetched'
  },
  googleCalendar: {
    title: 'Google Calendar Integration',
    enable: 'Enable Google Calendar integration',
    autoSync: 'Enable automatic synchronization',
    syncInterval: 'Sync Interval',
    interval1: 'Every 1 Hour',
    interval6: 'Every 6 Hours',
    interval12: 'Every 12 Hours',
    interval24: 'Every 24 Hours',
    interval168: 'Every Week',
    syncIntervalHint: 'Calendar will be synchronized automatically.',
    save: 'Save Google Calendar Settings',
    saveGoogleCalendarSettings: 'Save Google Calendar Settings',
    usage: 'Using Google Calendar:',
    usageText: 'You can export the payment calendar to Google Calendar from the calendar page.',
    usageHint: 'You can import the ICS file into Google Calendar.',
    syncIntervalLabel: 'Sync Interval (Hours)',
    interval1Hour: 'Every 1 Hour',
    interval6Hours: 'Every 6 Hours',
    interval12Hours: 'Every 12 Hours',
    interval24Hours: 'Every 24 Hours (Daily)',
    intervalWeek: 'Every Week',
    syncIntervalHintText: 'Calendar will be automatically synchronized to Google Calendar at the specified interval.'
  },
  advanced: {
    title: 'Advanced Settings',
    warning: 'Warning:',
    warningText: 'These operations cannot be undone.',
    clearCache: 'Clear Translation Cache',
    clearCacheDesc: 'Clears the cache of language translations.',
    clearCacheHint: 'Clear the cache to see translation updates.',
    clearCacheConfirm: 'Are you sure you want to clear the translation cache?',
    clearCacheButton: 'Clear Cache',
    cacheCleared: 'Translation cache cleared.',
    cacheClearError: 'Error occurred while clearing cache',
    deleteAllData: 'Delete All Data',
    deleting: 'Deleting...',
    deleteConfirm: 'All data will be deleted. Are you sure?',
    deletingData: 'Deleting data...',
    dataDeleted: 'All data deleted successfully',
    deleteError: 'Error occurred while deleting data',
    userNotFound: 'User information not found.',
    supabaseNotFound: 'Supabase connection not found',
    loadDemoData: 'Load Demo Data',
    loading: 'Loading...',
    loadDemoConfirm: 'Do you want to load demo data?',
    loadingDemo: 'Loading demo data...',
    demoLoaded: 'Demo data loaded successfully!',
    demoLoadError: 'Error occurred while loading demo data',
    demoProgress: 'Loading demo data...'
  },
  fetchError: 'Settings could not be loaded',
  saveSuccess: 'Settings saved successfully',
  saveError: 'Settings could not be saved',
  telegramNotifications: 'Telegram Notifications',
  telegramBotCreation: 'Telegram Bot Creation:',
  telegramStep1: 'Chat with',
  telegramStep2: 'Send',
  telegramStep3: 'Choose bot name and username',
  telegramStep4: 'BotFather will give you a',
  telegramStep5: 'Chat with',
  enableTelegram: 'Enable Telegram notifications',
  telegramBotTokenLabel: 'Telegram Bot Token *',
  telegramChatIdLabel: 'Telegram Chat ID *',
  telegramBotTokenHintText: 'Enter the bot token you received from BotFather',
  telegramChatIdHintText: 'Enter the chat ID where you want to receive notifications (you can learn it with @userinfobot)',
  sendTestNotification: 'Send Test Notification',
  saveSettings: 'Save Settings',
  sendingTest: 'Sending...',
  savingSettings: 'Saving...',
  testNotificationSent: 'Test notification sent successfully!',
  pleaseEnterTokenAndChatId: 'Please enter bot token and chat ID first',
  botTokenInvalid: 'Bot token is invalid.',
  chatIdNotFound: 'Chat ID not found.',
  backendNotFound: 'Backend endpoint not found.',
  apiError: 'API response error',
  corsError: 'Backend is not running.',
  sendingTelegramTest: 'Telegram test message is being sent...',
  exchangeRatesTitle: 'Exchange Rates',
  autoFetchRates: 'Auto Fetch Rates',
  fetchingRates: 'Fetching...',
  rateInfo: 'Rate Info:',
  rateInfoText: 'Rates are calculated based on TL.',
  usdTlRate: 'USD/TL Rate *',
  eurTlRate: 'EUR/TL Rate *',
  gbpTlRate: 'GBP/TL Rate *',
  gramGoldTlRate: 'Gram Gold/TL Rate *',
  ratePlaceholder: 'Ex: 34.50',
  goldPriceHint: 'Gram gold price must be updated manually',
  saveRates: 'Save Rates',
  fetchingRatesText: 'Fetching rates...',
  ratesUpdated: 'Rates updated',
  ratesCouldNotBeFetched: 'Rates could not be fetched.',
  goldPriceCouldNotBeFetched: 'Gold price could not be fetched automatically.',
  ratesCouldNotBeFetchedTCMB: 'Rates could not be fetched',
  fetchRatesAutomatically: 'Fetch Rates Automatically',
  googleCalendarTitle: 'Google Calendar Integration',
  enableGoogleCalendar: 'Enable Google Calendar integration',
  enableAutoSync: 'Enable automatic synchronization',
  syncIntervalLabel: 'Sync Interval (Hours)',
  every1Hour: 'Every 1 Hour',
  every6Hours: 'Every 6 Hours',
  every12Hours: 'Every 12 Hours',
  every24Hours: 'Every 24 Hours (Daily)',
  everyWeek: 'Every Week',
  syncIntervalHintText: 'Calendar will be automatically synchronized to Google Calendar at the specified interval.',
  saveGoogleCalendarSettings: 'Save Google Calendar Settings',
  googleCalendarUsage: 'Google Calendar Usage:',
  googleCalendarUsageText: 'You can export the payment calendar to Google Calendar from the calendar page.',
  googleCalendarUsageHint: 'You can import the ICS file into Google Calendar.',
  advancedSettingsTitle: 'Advanced Settings',
  warningTitle: 'Warning:',
  warningText: 'These operations cannot be undone.',
  clearTranslationCache: 'Clear Translation Cache',
  clearTranslationCacheDesc: 'Clears the cache of language translations.',
  clearTranslationCacheHint: 'Clear the cache to see translation updates.',
  clearCacheButton: 'Clear Cache',
  translationCacheCleared: 'Translation cache cleared.',
  errorClearingCache: 'Error occurred while clearing cache',
  deleteAllDataButton: 'Delete All Data',
  deletingDataText: 'Deleting...',
  deleteAllDataConfirm: 'All data will be deleted. Are you sure?',
  deletingDataText2: 'Deleting data...',
  allDataDeleted: 'All data deleted successfully',
  errorDeletingData: 'Error occurred while deleting data',
  loadDemoDataButton: 'Load Demo Data',
  loadingDemoDataText: 'Loading...',
  loadDemoDataConfirm: 'Do you want to load demo data?',
  loadingDemoDataText2: 'Loading demo data...',
  demoDataLoaded: 'Demo data loaded successfully!',
  errorLoadingDemoData: 'Error occurred while loading demo data',
  loadingDemoProgress: 'Loading demo data...',
  settingsCouldNotBeLoaded: 'Settings could not be loaded',
  settingsSavedSuccessfully: 'Settings saved successfully',
  settingsCouldNotBeSaved: 'Settings could not be saved',
  settingsLoadError: 'Settings could not be loaded: ',
  settingsSaveError: 'Settings could not be saved: ',
  ratesFetchedSuccessfully: 'Rates updated: ',
  ratesCouldNotBeFetchedText: 'Rates could not be fetched. Please enter manually.',
  ratesFetchErrorText: 'Rates could not be fetched: ',
  goldPriceCouldNotBeFetchedAuto: 'Gold price could not be fetched automatically. Please enter manually.',
  telegramTestSent: 'Test notification sent successfully! Check your Telegram.',
  telegramTestError: 'Test notification could not be sent',
  telegramBotTokenRequired: 'Please enter bot token and chat ID first',
  telegramBotTokenInvalidText: 'Bot token is invalid. Please check the token.',
  telegramChatIdNotFoundText: 'Chat ID not found. Please check the chat ID.',
  telegramBackendNotFound: 'Backend endpoint not found. Please make sure backend is running.',
  telegramApiError: 'API response error',
  telegramCorsError: 'Backend is not running. Please start the backend (npm run server:dev) or make sure http://localhost:5001 is accessible.',
  userNotFoundText: 'User information not found. Please login again.',
  supabaseNotFoundText: 'Supabase connection not found',
  allDataDeletedConfirm: 'All data will be deleted (except current user). Are you sure?',
  deletingDataText3: 'Deleting data...',
  allDataDeletedSuccessfully: 'All data deleted successfully (except current user)',
  errorDeletingDataText: 'Error occurred while deleting data: ',
  demoDataLoadConfirm: 'Are you sure you want to load demo data? Existing data may be overwritten.',
  loadingDemoDataText4: 'Loading demo data...',
  demoDataLoadedSuccessfully: 'Demo data loaded successfully!',
  errorLoadingDemoDataText: 'Error occurred while loading demo data: '
};
